import type { ThemeOptions } from '@mui/material/styles'

import { colours, fonts } from './tokens'

const heading = {
  fontFamily: fonts.heading,
  fontWeight: 400,
  lineHeight: 'normal',
  color: colours.blue,
} as const

export const typography: ThemeOptions['typography'] = {
  fontFamily: fonts.body,
  // The global root is 14px, but enabling this recalculates MUI's untouched rem-based
  // variants and would change their current rendered sizes.
  // htmlFontSize: 14,
  allVariants: {
    color: colours.blue,
  },
  h1: {
    ...heading,
    fontSize: '2em',
    textTransform: 'capitalize',
  },
  h2: {
    ...heading,
    fontSize: '1.7em',
  },
  h3: {
    ...heading,
    fontSize: '1.3em',
  },
  h4: {
    ...heading,
    fontSize: '1.2em',
  },
  h5: {
    ...heading,
    fontSize: '1.1em',
  },
  h6: {
    ...heading,
    fontSize: '1em',
  },
  body1: {
    fontFamily: fonts.body,
    fontSize: 14,
    color: colours.blue,
  },
  body2: {
    fontFamily: fonts.body,
    fontSize: 12,
    color: colours.blue,
  },
  button: {
    fontFamily: fonts.body,
    fontWeight: 700,
    fontSize: 15,
    letterSpacing: '0.23px',
  },
  subtitle2: {
    fontFamily: fonts.heading,
    fontSize: 14,
    letterSpacing: '0.21px',
    color: colours.blue,
  },
}
